module.exports = __webpack_public_path__ + "51e1509652ee07ffdc74a6553ec30854.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-0.png
// module id = 2101
// module chunks = 0